import React from 'react';
import { IosAppLayoutIcon, SideMenuBecomeHostPageIcon, SideMenuChangePasswordIcon, SideMenuDashboardIcon, SideMenuHomePageSettingsIcon, SideMenuManageAdminIcon, SideMenuManageCurrencyIcon, SideMenuPaymentGateWayIcon, SideMenuSearchSettingsIcon, SideMenuSiteConfigurationsIcon, SideMenuSiteSettingsIcon, SideMenuSiteSmtpSetupIcon, SideMenuSubArrow, SideMenuWhyHostMobileIcon, ReportTypeIcon, MobileLanguageIcon } from '../components/Common/Assets/SvgIconComponent/SideMenuIcons';
import { ServicePlanIcon, ManageCouponCodeSvg, SideMenuAdminReviewsIcon, SideMenuCarSettingsStepOneIcon, SideMenuCarSettingsStepThreeIcon, SideMenuContentManagementIcon, SideMenuDocumentVerificationIcon, SideMenuManageCarsIcon, SideMenuManageReportsIcon, SideMenuManageReservationsIcon, SideMenuManageReviewsIcon, SideMenuManageSecurityDepositIcon, SideMenuManageServiceFeeIcon, SideMenuManageUsersIcon, SideMenuMessagesIcon, SideMenuPayoutManagementIcon, SideMenuStaticContentManagementIcon, ManageAIFeatureSvg, SendNotificationIcon } from '../components/Common/Assets/SvgIconComponent/SideMenuRemainingIcons';

const getDashboardSideMenu = [
    {
        label: "dashboard",
        activePaths: ["/siteadmin/dashboard"],
        href: "/siteadmin",
        icon: <SideMenuDashboardIcon />,
        isValidatePrivilege: false
    }
];

const getConfigurationSideMenu = [
    {
        label: "siteSettings",
        activePaths: ["/siteadmin/settings/site"],
        href: "/siteadmin/settings/site",
        icon: <SideMenuSiteSettingsIcon />,
        isValidatePrivilege: true,
        privilegeId: 1
    },
    {
        label: "boAdminMenu",
        activePaths: ["/siteadmin/settings/booking-options"],
        href: "/siteadmin/settings/booking-options",
        icon: <SideMenuSiteSettingsIcon />,
        isValidatePrivilege: true,
        privilegeId: 1
    },
    {
        label: "inspAdmMenu",
        activePaths: ["/siteadmin/settings/inspection"],
        href: "/siteadmin/settings/inspection",
        icon: <SideMenuSiteSettingsIcon />,
        isValidatePrivilege: true,
        privilegeId: 1
    },
    {
        label: "manageSiteConfig",
        activePaths: ["/siteadmin/settings/config"],
        href: "/siteadmin/settings/config",
        icon: <SideMenuSiteConfigurationsIcon />,
        isValidatePrivilege: true,
        privilegeId: 1
    },
    {
        label: "appLayoutSettings",
        activePaths: ["/siteadmin/settings/ios-layout"],
        href: "/siteadmin/settings/ios-layout",
        icon: <IosAppLayoutIcon />,
        isValidatePrivilege: true,
        privilegeId: 21
    },
    {
        label: "manageLocalization",
        paths: [
            "/siteadmin/mobile-language",
            "/siteadmin/mobile-language/android_app", "/siteadmin/mobile-language/iOS_app", "/siteadmin/mobile-language/flutter_app",
            "/siteadmin/mobile-language/android_app/edit", "/siteadmin/mobile-language/iOS_app/edit", "/siteadmin/mobile-language/flutter_app/edit",
        ],
        isAccordion: true,
        icon: <MobileLanguageIcon />,
        isValidatePrivilege: true,
        privilegeId: 23,
        matchType: 'regex',
        data: [
            {
                label: "mobileLanguagePageTitle",
                activePaths: ["/siteadmin/mobile-language", "/siteadmin/mobile-language/android_app", "/siteadmin/mobile-language/android_app/edit", "/siteadmin/mobile-language/iOS_app", "/siteadmin/mobile-language/iOS_app/edit", "/siteadmin/mobile-language/flutter_app", "/siteadmin/mobile-language/flutter_app/edit"],
                href: "/siteadmin/mobile-language",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 23,
                matchType: 'regex',
            },

        ]
    },
    {
        label: "manageAiFeature",
        activePaths: ["/siteadmin/ai-features"],
        href: "/siteadmin/ai-features",
        icon: <ManageAIFeatureSvg />,
        isValidatePrivilege: true,
        privilegeId: 26
    },
    {
        label: "smsSettings",
        activePaths: ["/siteadmin/settings/sms"],
        href: "/siteadmin/settings/sms",
        icon: <SideMenuMessagesIcon />,
        isValidatePrivilege: false
    },
    {
        label: "smtpCredentialsLabel",
        activePaths: ["/siteadmin/smtp-setup"],
        href: "/siteadmin/smtp-setup",
        icon: <SideMenuSiteSmtpSetupIcon />,
        isValidatePrivilege: true,
        privilegeId: 22
    },
    {
        label: "manageCurrency",
        activePaths: ["/siteadmin/currency"],
        href: "/siteadmin/currency",
        icon: <SideMenuManageCurrencyIcon />,
        isSuperAdmin: true,
        isValidatePrivilege: true
    },
    {
        label: "searchSettings",
        activePaths: ["/siteadmin/settings/search"],
        href: "/siteadmin/settings/search",
        icon: <SideMenuSearchSettingsIcon />,
        isValidatePrivilege: true,
        privilegeId: 14
    },
    {
        label: "managePaymentGateWay",
        activePaths: ["/siteadmin/payment-gateway-section"],
        href: "/siteadmin/payment-gateway-section",
        icon: <SideMenuPaymentGateWayIcon />,
        isValidatePrivilege: true,
        privilegeId: 12
    },
    {
        label: "homePageSettings",
        paths: ['/siteadmin/home/caption', '/siteadmin/home/find-your-car', '/siteadmin/popularlocation',
            '/siteadmin/home/static-info-block', '/siteadmin/home/banner', '/siteadmin/home/footer-block',
            '/siteadmin/popularlocation/add', '/siteadmin/edit/popularlocation'],
        isAccordion: true,
        icon: <SideMenuHomePageSettingsIcon />,
        isValidatePrivilege: true,
        privilegeId: 15,
        matchType: 'regex',
        data: [
            {
                label: "bannerCaptionLabel",
                activePaths: ["/siteadmin/home/caption"],
                href: "/siteadmin/home/caption",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 15
            },
            {
                label: "findYourCar",
                activePaths: ["/siteadmin/home/find-your-car"],
                href: "/siteadmin/home/find-your-car",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 15
            },
            {
                label: "managePopularLocations",
                activePaths: ["/siteadmin/popularlocation", "/siteadmin/edit/popularlocation", "/siteadmin/popularlocation/add"],
                href: "/siteadmin/popularlocation",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 15,
                matchType: 'regex'
            },
            {
                label: "imageBannerLabel",
                activePaths: ["/siteadmin/home/banner"],
                href: "/siteadmin/home/banner",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 15
            },
            {
                label: "staticInfoBlock",
                activePaths: ["/siteadmin/home/static-info-block"],
                href: "/siteadmin/home/static-info-block",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 15
            },
            {
                label: "footerBlockLabel",
                activePaths: ['/siteadmin/home/footer-block'],
                href: '/siteadmin/home/footer-block',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 15
            }
        ]
    },
    {
        label: "whyHostPage",
        activePaths: ["/siteadmin/why-host"],
        href: "/siteadmin/why-host",
        icon: <SideMenuWhyHostMobileIcon />,
        isValidatePrivilege: true,
        privilegeId: 16
    },
    {
        label: "whyBecomeOwnerPage",
        paths: ['/siteadmin/whyHost/Block1', '/siteadmin/whyHost/Block2', '/siteadmin/whyHost/Block3', '/siteadmin/whyHost/Block4',
            '/siteadmin/whyHost/Block5', '/siteadmin/whyHost/review', '/siteadmin/whyHost/Block7', '/siteadmin/whyHost/review/add/',
            '/siteadmin/whyHost/review/edit/'
        ],
        isAccordion: true,
        icon: <SideMenuBecomeHostPageIcon />,
        isValidatePrivilege: true,
        privilegeId: 16,
        matchType: 'regex',
        data: [
            {
                label: "blockLabel1",
                activePaths: ['/siteadmin/whyHost/Block1'],
                href: '/siteadmin/whyHost/Block1',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16
            },
            {
                label: "blockLabel2",
                activePaths: ['/siteadmin/whyHost/Block2'],
                href: '/siteadmin/whyHost/Block2',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16
            },
            {
                label: "blockLabel3",
                activePaths: ['/siteadmin/whyHost/Block3'],
                href: '/siteadmin/whyHost/Block3',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16
            },
            {
                label: "blockLabel4",
                activePaths: ['/siteadmin/whyHost/Block4'],
                href: '/siteadmin/whyHost/Block4',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16
            },
            {
                label: "blockLabel5",
                activePaths: ['/siteadmin/whyHost/Block5'],
                href: '/siteadmin/whyHost/Block5',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16
            },
            {
                label: "blockLabel6",
                activePaths: ['/siteadmin/whyHost/review', '/siteadmin/whyHost/review/add/', '/siteadmin/whyHost/review/edit/'],
                href: '/siteadmin/whyHost/review',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16,
                matchType: 'regex'
            },
            {
                label: "blockLabel7",
                activePaths: ['/siteadmin/whyHost/Block7'],
                href: '/siteadmin/whyHost/Block7',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16
            }
        ]
    },
];

const getAdminConfigSideMenu = [
    {
        label: "manageAdmin",
        paths: ['/siteadmin/admin-users', '/siteadmin/admin-roles'],
        isAccordion: true,
        icon: <SideMenuManageAdminIcon />,
        isValidatePrivilege: true,
        isSuperAdmin: true,
        data: [
            {
                label: "manageAdminUsers",
                activePaths: ['/siteadmin/admin-users'],
                href: '/siteadmin/admin-users',
                icon: <SideMenuSubArrow />,
            },
            {
                label: "manageAdminRoles",
                activePaths: ['/siteadmin/admin-roles'],
                href: '/siteadmin/admin-roles',
                icon: <SideMenuSubArrow />,
            },
        ]
    },
    {
        label: "changePasswordLabel",
        activePaths: ["/siteadmin/change/admin"],
        href: "/siteadmin/change/admin",
        icon: <SideMenuChangePasswordIcon />,
        isValidatePrivilege: false
    },
];

const getUsersSideMenu = [
    {
        label: "manageUser",
        activePaths: ["/siteadmin/users", "/siteadmin/edit-profile/", "/siteadmin/profileView/"],
        href: "/siteadmin/users",
        icon: <SideMenuManageUsersIcon />,
        isValidatePrivilege: true,
        privilegeId: 2
    },
    {
        label: "documentVerification",
        activePaths: ["/siteadmin/document"],
        href: "/siteadmin/document",
        icon: <SideMenuDocumentVerificationIcon />,
        isValidatePrivilege: true,
        privilegeId: 8
    },
    {
        label: "reportManagement",
        activePaths: ["/siteadmin/reportUser"],
        href: "/siteadmin/reportUser",
        icon: <SideMenuManageReportsIcon />,
        isValidatePrivilege: true,
        privilegeId: 10
    },
    {
        label: "reportType",
        activePaths: ["/siteadmin/report-type"],
        href: "/siteadmin/report-type",
        icon: <ReportTypeIcon />,
        isValidatePrivilege: true,
        privilegeId: 24
    }
];

const getCarSettingsMenu = [
    {
        label: "carSettingsForStep1",
        paths: ['/siteadmin/listsettings/1', '/siteadmin/listsettings/20', '/siteadmin/listsettings/3',
            '/siteadmin/listsettings/4', '/siteadmin/listsettings/10', '/siteadmin/listsettings/21'
        ],
        isAccordion: true,
        icon: <SideMenuCarSettingsStepOneIcon />,
        isValidatePrivilege: true,
        privilegeId: 17,
        data: [
            {
                label: "carType",
                activePaths: ['/siteadmin/listsettings/1'],
                href: '/siteadmin/listsettings/1',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 17
            },
            {
                label: "makeLabel",
                activePaths: ['/siteadmin/listsettings/20'],
                href: '/siteadmin/listsettings/20',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 17
            },
            {
                label: "modelLabel",
                activePaths: ['/siteadmin/listsettings/3'],
                href: '/siteadmin/listsettings/3',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 17
            },
            {
                label: "year",
                activePaths: ['/siteadmin/listsettings/4'],
                href: '/siteadmin/listsettings/4',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 17
            },
            {
                label: "carFeatures",
                activePaths: ['/siteadmin/listsettings/10'],
                href: '/siteadmin/listsettings/10',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 17
            },
            {
                label: "odometer",
                activePaths: ['/siteadmin/listsettings/21'],
                href: '/siteadmin/listsettings/21',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 17
            },
        ]
    },
    {
        label: "carSettingsForStep3",
        paths: ['/siteadmin/listsettings/13', '/siteadmin/listsettings/14', '/siteadmin/listsettings/15',
            '/siteadmin/listsettings/18', '/siteadmin/listsettings/19'
        ],
        isAccordion: true,
        icon: <SideMenuCarSettingsStepThreeIcon />,
        isValidatePrivilege: true,
        privilegeId: 17,
        data: [
            {
                label: "carRules",
                activePaths: ['/siteadmin/listsettings/14'],
                href: '/siteadmin/listsettings/14',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 17
            },
            {
                label: "reviewHowRentersBook",
                activePaths: ['/siteadmin/listsettings/15'],
                href: '/siteadmin/listsettings/15',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 17
            },
            {
                label: "minimumDays",
                activePaths: ['/siteadmin/listsettings/18'],
                href: '/siteadmin/listsettings/18',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 17
            },
            {
                label: "maximumDays",
                activePaths: ['/siteadmin/listsettings/19'],
                href: '/siteadmin/listsettings/19',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 17
            },
        ]
    },
];

const getCarsMenu = [
    {
        label: "manageListing",
        activePaths: ['/siteadmin/listings'],
        href: '/siteadmin/listings',
        icon: <SideMenuManageCarsIcon />,
        isValidatePrivilege: true,
        privilegeId: 3
    }
];

const getReservationMenu = [
    {
        label: "manageServiceFee",
        activePaths: ['/siteadmin/settings/servicefees'],
        href: '/siteadmin/settings/servicefees',
        icon: <SideMenuManageServiceFeeIcon />,
        isValidatePrivilege: true,
        privilegeId: 7
    },
    {
        label: "manageReservations",
        activePaths: ['/siteadmin/reservations', '/siteadmin/viewreservation/'],
        href: '/siteadmin/reservations',
        icon: <SideMenuManageReservationsIcon />,
        isValidatePrivilege: true,
        privilegeId: 4,
        matchType: 'regex'
    },
    {
        label: "manageCouponCode",
        activePaths: ['/siteadmin/promo-code'],
        href: '/siteadmin/promo-code',
        icon: <ManageCouponCodeSvg />,
        isValidatePrivilege: true,
        privilegeId: 25,
        matchType: 'regex'
    },
    {
        label: "servicePlanLabel",
        activePaths: ['/siteadmin/service-plans', '/siteadmin/service-plans/add', '/siteadmin/service-plans/edit/', '/siteadmin/user-purchased-plans'],
        icon: <ServicePlanIcon />,
        isValidatePrivilege: true,
        isAccordion: true,
        privilegeId: 27,
        matchType: 'regex',
        data: [
            {
                label: "servicePlans",
                activePaths: ['/siteadmin/service-plans', '/siteadmin/service-plans/add', '/siteadmin/service-plans/edit/'],
                href: '/siteadmin/service-plans',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                matchType: 'regex'
            },
            {
                label: "servicePlanUsers",
                activePaths: ['/siteadmin/user-purchased-plans'],
                href: '/siteadmin/user-purchased-plans',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                matchType: 'regex'
            },
        ]
    },
    {
        label: "manageSecurityDeposit",
        activePaths: ['/siteadmin/manage-security-deposit', '/siteadmin/viewreservation/'],
        href: '/siteadmin/manage-security-deposit',
        icon: <SideMenuManageSecurityDepositIcon />,
        isValidatePrivilege: true,
        privilegeId: 20,
        matchType: 'regex'
    },
    {
        label: "messages",
        activePaths: ['/siteadmin/messages'],
        href: '/siteadmin/messages',
        icon: <SideMenuMessagesIcon />,
        isValidatePrivilege: true,
        privilegeId: 9
    },
    {
        label: "payOutManagement",
        activePaths: ['/siteadmin/payout', '/siteadmin/viewpayout/'],
        href: '/siteadmin/payout',
        icon: <SideMenuPayoutManagementIcon />,
        isValidatePrivilege: true,
        privilegeId: 11
    },
    {
        label: "manageReviews",
        activePaths: ['/siteadmin/user-reviews', '/siteadmin/management-reviews/'],
        href: '/siteadmin/user-reviews',
        icon: <SideMenuManageReviewsIcon />,
        isValidatePrivilege: true,
        privilegeId: 5
    },
    {
        label: "adminReviews",
        paths: ['/siteadmin/reviews', '/siteadmin/edit-review', '/siteadmin/write-reviews'],
        isAccordion: true,
        icon: <SideMenuAdminReviewsIcon />,
        isValidatePrivilege: true,
        privilegeId: 6,
        data: [
            {
                label: "manageAdminReviews",
                activePaths: ['/siteadmin/reviews', '/siteadmin/edit-review'],
                href: '/siteadmin/reviews',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 6,
                matchType: 'regex'
            },
            {
                label: "writeReviews",
                activePaths: ['/siteadmin/write-reviews'],
                href: '/siteadmin/write-reviews',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 6,
            },
        ]
    },
];

const getContentPageMenu = [
    {
        label: "contentManagementLabel",
        activePaths: ['/siteadmin/content-management', '/siteadmin/edit/page/', '/siteadmin/page/add'],
        href: '/siteadmin/content-management',
        icon: <SideMenuContentManagementIcon />,
        isValidatePrivilege: true,
        privilegeId: 18
    },
    {
        label: "staticContentManagement",
        activePaths: ['/siteadmin/staticpage/management', '/siteadmin/edit/staticpage/'],
        href: '/siteadmin/staticpage/management',
        icon: <SideMenuStaticContentManagementIcon />,
        isValidatePrivilege: true,
        privilegeId: 19
    }
];

const announcementSideMenu = [

    {
        label: "manageNotifications",
        activePaths: ["/siteadmin/notifications"],
        href: "/siteadmin/notifications",
        icon: <SendNotificationIcon />,
        isValidatePrivilege: true,
        privilegeId: 28
    },
]

export {
    getDashboardSideMenu,
    getConfigurationSideMenu,
    getAdminConfigSideMenu,
    getUsersSideMenu,
    getCarSettingsMenu,
    getCarsMenu,
    getReservationMenu,
    getContentPageMenu,
    announcementSideMenu
}